import {Input} from 'antd';
import {FormItemProps} from 'antd/es/form';
import {InputProps} from 'antd/es/input/Input';
import cn from 'classnames';
import React, {ReactNode} from 'react';

import {isTruthy} from 'shared/utils';

import s from './static-form-item.module.less';

type TStaticFormItemClassNames = {
    wrapperClassName?: cn.Argument;
    labelClassName?: cn.Argument;
    valueClassName?: cn.Argument;
}

type TStaticFormItemCommonProps = {
    classNames?: TStaticFormItemClassNames;
    placeholder?: string;
    label: FormItemProps['label'];
}

type TStaticFormItemWithValueProps = TStaticFormItemCommonProps & {
    value: InputProps['value'];
    valuePrefix?: ReactNode;
    customValue?: never;
}

type TStaticFormItemWithCustomValueProps = TStaticFormItemCommonProps & {
    value?: never;
    valuePrefix?: never;
    customValue: ReactNode;
}

type TStaticFormItemProps =
    TStaticFormItemWithValueProps | TStaticFormItemWithCustomValueProps;

export const StaticFormItem = ({
    classNames,
    placeholder,
    label,
    value,
    valuePrefix,
    customValue,
}: TStaticFormItemProps) => {
    const {
        wrapperClassName,
        labelClassName,
        valueClassName,
    } = classNames ?? {};

    return (
        <div className={cn(s.wrapper, wrapperClassName)}>
            <div className={cn(s.label, labelClassName)}>{label}</div>
            {placeholder && !value && (
                <div className={s.placeholder}>
                    {placeholder}
                </div>
            )}
            {}
            {(isTruthy(value) || isTruthy(customValue)) && (
                <div className={s['value-wrapper']}>
                    {(() => {
                        if (isTruthy(value)) {
                            return (
                                <>
                                    {valuePrefix}
                                    <Input
                                        className={cn(s['input-value'], valueClassName)}
                                        value={value}
                                        disabled
                                    />
                                </>
                            );
                        }
                        if (isTruthy(customValue)) {
                            return customValue;
                        }

                        return null;
                    })()}
                </div>
            )}
        </div>
    );
};
